import { useQuery } from '@apollo/client';
import { useRouter } from '@application/utils';
import { graphql } from '@gql/gql';
import type { ApplicationGetBreederQuery, ApplicationGetBreederQueryVariables } from '@gql/graphql';

export const APPLICATION_GET_BREEDER = graphql(`
  query ApplicationGetBreeder(
    $where: DogBreederWhereUniqueInput!
    $translationsWhere: DogBreederTranslationWhereInput!
    $breederCardInfoTranslationsWhereBreed: DogBreedTranslationWhereInput!
  ) {
    findUniqueDogBreeder(where: $where) {
      id
      spokenLanguages
      translations(where: $translationsWhere) {
        id
        url
      }
      breederBreeds {
        id
        dogBreed {
          id
          translations(where: $breederCardInfoTranslationsWhereBreed) {
            id
            name
          }
        }
      }
    }
  }
`);

export const useGetBreeder = (breederId: number) => {
  const { language } = useRouter();

  const { loading, data } = useQuery<
    ApplicationGetBreederQuery,
    ApplicationGetBreederQueryVariables
  >(APPLICATION_GET_BREEDER, {
    variables: {
      where: { id: breederId },
      translationsWhere: { language: { equals: language } },
      breederCardInfoTranslationsWhereBreed: { language: { equals: language } },
    },
    ssr: false,
  });

  return {
    breederLoading: loading,
    breeder: data?.findUniqueDogBreeder,
  };
};
